import React, { useState } from "react";
import { Row, Form, Input, Label } from "reactstrap";
import "./EditModal.css";

const EditModal = (props) => {

  const [selectedValue, setSelectedValue] = useState(props.respondentRelationship);
  const handleSelect = (e) => {
    props.handleDropdownOptions(e)
    setSelectedValue(e)


  }

  const rearrangedOptions = [...props.dropDownOptions];

  const selectedIndex = rearrangedOptions.findIndex(
    (getValues) => getValues.assessor_group__assessor_name === props.respondentRelationship
  );

  if (selectedIndex !== -1) {
    rearrangedOptions.unshift(rearrangedOptions.splice(selectedIndex, 1)[0]);
  }
  return (
    <div className="Edit-modal">
      <Form>
        <Row form>
          <Label className="label">EMAIL ID</Label>
        </Row>
        <Row form>
          <Input
            type="email"
            className="email-input"
            readOnly
            value={props.respondentEmail}
          />
        </Row>
        <Row form>
          <Label className="label mt-3">RELATIONSHIP</Label>
        </Row>
        <Row form>
          <Input
            id="relation"
            type="select"
            value={selectedValue}
            className="drop-down"
            onChange={(e) => handleSelect(e.target.value)}
          >
            {rearrangedOptions.map((getValues) => (
              <option key={getValues.id} value={getValues.assessor_group}>
                {getValues.assessor_group__assessor_name}
              </option>
            ))}
          </Input>
        </Row>

        <div className="buttons">
          <input type="reset" className="reset" value="RESET" />
          {props.sentRespondantsId === props.sentRespondantsFilteredId ? (
            <button
              onClick={(e) => {
                e.preventDefault();
                props.handleEditModalSubmit(
                  props.assessmentUserId,
                  props.relationShipId,
                  props.accessorGroupId
                );
              }}
              className="submit"
            >
              SUBMIT
            </button>
          ) : (
            <button
              onClick={() =>
                props.handleUnfilteredEditModalSubmit(
                  props.assessmentUserId,
                  props.relationShipId,
                  props.accessorGroupId
                )
              }
              className="submit"
            >
              SUBMIT
            </button>
          )}
        </div>
      </Form>
    </div>
  );
};

export default EditModal;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Invitation-Modal/Edit-Modal/EditModal.jsx